import { render, staticRenderFns } from "./Sparkles.vue?vue&type=template&id=26e233b4&"
import script from "./Sparkles.vue?vue&type=script&lang=js&"
export * from "./Sparkles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3194833414/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26e233b4')) {
      api.createRecord('26e233b4', component.options)
    } else {
      api.reload('26e233b4', component.options)
    }
    module.hot.accept("./Sparkles.vue?vue&type=template&id=26e233b4&", function () {
      api.rerender('26e233b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/icons/Sparkles.vue"
export default component.exports